var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio-group',{attrs:{"options":_vm.schema.options,"name":"radio-inline","buttons":"","button-variant":"primary"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }